import { render, staticRenderFns } from "./genderBarChart.vue?vue&type=template&id=bd82b354&scoped=true"
import script from "./genderBarChart.vue?vue&type=script&lang=js"
export * from "./genderBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd82b354",
  null
  
)

export default component.exports